import { PageStrings } from './pages';
import { ComponentStrings } from './components';
import Modal from './Modal';
import Common from './Common';

export const en = { Modal, Common, ...PageStrings, ...ComponentStrings };
